import type { FC } from 'react';
import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getPagingMode } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { useSelector } from 'react-redux';
import { getCurrentPage } from '../../../../selectors/pageInfo';
import FolderPagedContent from './FolderPagedContent';
import FolderInfiniteContent from './FolderInfiniteContent';
import { AppState } from '../../../../../types/store';

export interface Props {
  folderId: number;
}
const FolderContent: FC<Props> = ({ folderId }) => {
  const pagingMode = useSelector((state: AppState) => getPagingMode(state));
  const currentPage = useSelector(getCurrentPage);
  const isMobile = useContext(MobileContext);
  const isPagedRequest = currentPage > 1;

  if (!isMobile && (pagingMode === 'page' || isPagedRequest)) {
    return <FolderPagedContent folderId={folderId} />;
  }
  return <FolderInfiniteContent folderId={folderId} />;
};

export default FolderContent;
